import type React from "react";

type TextStyle = React.CSSProperties;

export const textStyles = {
  displayXL: {
    fontFamily: "var(--type-display-xl-font-family)",
    fontSize: "var(--type-display-xl-font-size)",
    fontWeight: "var(--type-display-xl-font-weight)",
    lineHeight: "var(--type-display-xl-line-height)",
  },
  display: {
    fontFamily: "var(--type-display-font-family)",
    fontSize: "var(--type-display-font-size)",
    fontWeight: "var(--type-display-font-weight)",
    lineHeight: "var(--type-display-line-height)",
  },
  heading1: {
    fontFamily: "var(--type-heading-1-font-family)",
    fontSize: "var(--type-heading-1-font-size)",
    fontWeight: "var(--type-heading-1-font-weight)",
    lineHeight: "var(--type-heading-1-line-height)",
  },
  heading2: {
    fontFamily: "var(--type-heading-2-font-family)",
    fontSize: "var(--type-heading-2-font-size)",
    fontWeight: "var(--type-heading-2-font-weight)",
    lineHeight: "var(--type-heading-2-line-height)",
  },
  heading3: {
    fontFamily: "var(--type-heading-3-font-family)",
    fontSize: "var(--type-heading-3-font-size)",
    fontWeight: "var(--type-heading-3-font-weight)",
    lineHeight: "var(--type-heading-3-line-height)",
  },
  body: {
    fontFamily: "var(--type-body-font-family)",
    fontSize: "var(--type-body-font-size)",
    fontWeight: "var(--type-body-font-weight)",
    lineHeight: "var(--type-body-line-height)",
  },
  caption: {
    fontFamily: "var(--type-caption-font-family)",
    fontSize: "var(--type-caption-font-size)",
    fontWeight: "var(--type-caption-font-weight)",
    lineHeight: "var(--type-caption-line-height)",
  },
  button: {
    fontFamily: "var(--type-button-font-family)",
    fontSize: "var(--type-button-font-size)",
    fontWeight: "var(--type-button-font-weight)",
    lineHeight: "var(--type-button-line-height)",
  },
  textButton: {
    display: "inline",
    fontFamily: "var(--type-button-font-family)",
    fontSize: "var(--type-button-font-size)",
    fontWeight: "var(--type-button-font-weight)",
    lineHeight: "var(--type-button-line-height)",
    verticalAlign: "baseline",
  },
} satisfies Record<string, TextStyle>;

export const textButtonStyle = textStyles.textButton;
